import React , { Component } from 'react';

import { findBrowser } from './../../../operations/operations';
import { BROWSER_NAME } from './../../../operations/constants';
import ModalComponent from './../../core/ModalComponent';
import InfoLine from 'sushiweb/Icons/all/InfoLine';
import Unlock from 'sushiweb/Icons/all/Unlock';
import './NoLocationFound.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class NoLocationFound extends Component {

    renderLocationTitle = () => {
        return(
          <React.Fragment>
            Allow Access to Location
          </React.Fragment>
        )
    }

    renderLocationBody = () => {
        const instructions = this.renderLocationIntruction();
        const { hideLocationModal } = this.props;
        return(
          <div className="instructions">
            <img src={'../../images/Location.png'}/>
            {instructions}
            <div className="btn btn-green mt-2" onClick={() => hideLocationModal()}>{this.props.buttonText}</div>
          </div>
        )
      }

    renderLocationIntruction = () => {
        const browserName = findBrowser();

        if (browserName === BROWSER_NAME.SAFARI) {
          return(
            <div className="fs-16">
              1. Ensure to switch ON the location in your device. 
                Once the location is ON follow the following steps <br />
              2. To the left of the web address, click the <strong>AA</strong> icon that you see.<br/>
              3. Click "Website settings".<br/>
              4. Click on location and then click on <strong>"Allow"</strong><br/>
              5. Upload photo. You will be asked to give location access. Click on <strong>"Access"</strong>.<br/>
            </div>
          )
        }
         else if (browserName === BROWSER_NAME.FIREFOX) {
          return(
            <div className="fs-16">
              1. Ensure to switch ON the location in your device. 
              Once the location is ON follow the following steps <br />
              2. To the left of the web address, click the icon that you see:
              <FontAwesomeIcon icon="lock" className="ml-1 mr-1 gray-text" />
              <FontAwesomeIcon icon="info-circle" className="gray-text" /> <br />
              3. Click "Edit site settings".<br/>
              4. Check location (Don't share) checkbox and then click on <strong>"Clear"</strong><br/>
              5. Upload photo. You will be asked to give location access. Click on <strong>"Access"</strong>.<br/>
            </div>
          )
        } else if(browserName === BROWSER_NAME.CHROME) {
          return (
            <div className="fs-16 mt-1">
              1. Ensure to switch ON the location in your device.
              Once the location is ON follow the following steps <br />
              2. To the left of the web address, click the icon that you see:
              <FontAwesomeIcon icon="lock" className="ml-1 mr-1 gray-text" />
              <FontAwesomeIcon icon="info-circle" className="gray-text" /> <br />
              3. Click "Site settings".<br />
              4. Click on location access and then click <strong>"Allow"</strong>.<br />
              5. Upload photo. You will be asked to give location access. Click on <strong>"Access"</strong>.<br />
            </div>
          )
        }
      }

    render() {
        const {isOpen , hideLocationModal} = this.props;
        return (
            <ModalComponent 
          isOpen={isOpen}
          onClose={hideLocationModal}
          title={this.renderLocationTitle()}
          body={this.renderLocationBody()}
        />
        )
    }
}

export default NoLocationFound;
